"use client";
import React, { useState } from "react";
import MainNav from "./main-nav";
import { NavigationItem } from "./types";
import MobileNav from "./mobile-nav";
import { Link, graphql, useStaticQuery } from "gatsby";
import useGetNav from "./hooks/use-get-nav";

export type NavbarProps = {};
export const Navbar: React.FC<NavbarProps> = ({}) => {
  const navItems: NavigationItem[] | undefined = useGetNav({
    location: "Header",
  })?.navItems;

  //console.log("query result", navItems);

  const [closed, setClosed] = useState(true);

  return (
    <div className="flex flex-wrap sm:justify-start sm:flex-nowrap  w-full text-sm py-4">
      {navItems && (
        <div
          className="max-w-[85rem] w-full mx-auto px-4 flex items-center justify-between"
          aria-label="Global"
        >
          <MainNav nav={{ navigationItems: navItems }} />
          <MobileNav nav={{ navigationItems: navItems }} />
        </div>
      )}
    </div>
  );
};

export default Navbar;
